'use client';
import React, { useRef } from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { BaseTooltip } from '@/components';

interface MarkerPopoverProps {
  onEnterSelectionMode: () => void;
  isSelectionMode?: boolean;
  disabled?: boolean;
  label?: string; // Custom label for the button (e.g., "Timestamps" for sensors, "Markers" for spectrum)
}

export const MarkerPopover: React.FC<MarkerPopoverProps> = ({
  isSelectionMode = false,
  disabled = false,
  onEnterSelectionMode,
  label = 'Markers',
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  return (
    <BaseTooltip content="Click to add markers by clicking on the chart">
      <Button
        ref={buttonRef}
        variant="ghost"
        size="sm"
        className={`gap-2 ${isSelectionMode ? 'bg-secondary text-primary-500 font-semibold' : 'text-[#55687d]'}`}
        disabled={disabled}
        onClick={() => {
          onEnterSelectionMode();
        }}
      >
        <Plus className="w-4 h-4" />
        {label}
      </Button>
    </BaseTooltip>
  );
};
